import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  UtimacoCircuitSwitch,
  API_PATH_UTIMACO_CIRCUIT_SWITCH,
} from './utimacoCircuitSwitch.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getUtimacoCircuitSwitchList(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<UtimacoCircuitSwitch>> {
  return http.get(`${API_PATH_UTIMACO_CIRCUIT_SWITCH}/${deliveryFunctionId}`);
}

export function getUtimacoCircuitSwitch(
  deliveryFunctionId: string,
  id: string,
): AxiosPromise<ServerResponse<UtimacoCircuitSwitch>> {
  return http.get(`${API_PATH_UTIMACO_CIRCUIT_SWITCH}/${deliveryFunctionId}/${id}`);
}

export function createUtimacoCircuitSwitch(
  deliveryFunctionId: string,
  body: WithAuditDetails<UtimacoCircuitSwitch>,
): AxiosPromise<ServerResponse<UtimacoCircuitSwitch>> {
  return http.post(`${API_PATH_UTIMACO_CIRCUIT_SWITCH}/${deliveryFunctionId}`, body);
}

export function updateUtimacoCircuitSwitch(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<UtimacoCircuitSwitch>,
): AxiosPromise<ServerResponse<UtimacoCircuitSwitch>> {
  return http.put(`${API_PATH_UTIMACO_CIRCUIT_SWITCH}/${deliveryFunctionId}/${id}`, body);
}

export function deleteUtimacoCircuitSwitch(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<UtimacoCircuitSwitch>> {
  return http.delete(`${API_PATH_UTIMACO_CIRCUIT_SWITCH}/${deliveryFunctionId}/${id}`, { data: body.auditDetails });
}
